interface MembershipOrderItem {
  id: string;
  orderId: string;
  title: string;
  amount: number;
  date: string;
  expireAt?: string;
  status: 'paid' | 'pending' | 'closed';
}

const STATUS_TEXT = {
  paid: '已付款',
  pending: '待支付',
  closed: '已關閉'
};

const MembershipOrders = ({
  orders,
  onContinuePay
}: {
  orders: MembershipOrderItem[];
  onContinuePay: (id: string) => void;
}) => {
  if (!orders.length) {
    return <div className="rounded-2xl border border-slate-100 bg-white py-16 text-center text-sm text-slate-400">暫無會員訂單</div>;
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-100 bg-white">
      <div className="divide-y divide-slate-50">
        {orders.map((order) => (
          <div key={order.id} className="flex items-center justify-between gap-4 px-6 py-5">
            <div>
              <p className="text-sm font-semibold text-[#0A1628]">{order.title}</p>
              <p className="mt-1 font-mono text-[11px] text-slate-400">{order.orderId}</p>
              {order.expireAt ? <p className="mt-1 text-[11px] text-emerald-600">有效至 {order.expireAt}</p> : null}
            </div>
            <div className="flex items-center gap-6">
              <div className="text-right">
                <p className="text-sm font-bold text-[#0A1628]">${order.amount}</p>
                <p className="mt-1 text-[11px] text-slate-400">{order.date || '待同步'}</p>
                <p className="mt-1 text-[11px] text-violet-600">{STATUS_TEXT[order.status]}</p>
              </div>
              {order.status === 'pending' ? (
                <button
                  onClick={() => onContinuePay(order.id)}
                  className="rounded-xl bg-violet-600 px-4 py-2 text-xs font-bold text-white transition-colors hover:bg-violet-700"
                >
                  繼續付款
                </button>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembershipOrders;
